module.exports = __webpack_public_path__ + "img/btn-icon-3.c6447c36.png";